import {VotingResult} from "@/entities/voting/VotingResult";
import {Branch} from "@/entities/Branch";
import {Account} from "@/entities/auth/Account";
import {DiseaseParametersModel} from "@/entities/diseaseParameters/DiseaseParametersModel";
import {VotingType} from "@/entities/voting/VotingType";
import {VotingResultType} from "@/entities/voting/VotingResultType";
import {VotesType} from "@/entities/voting/VotesType";
import {VotingStatus} from "@/entities/voting/VotingStatus";

export class Voting {
    id: number;
    name: string;
    branch: Branch;
    type: VotingType;
    status: VotingStatus;
    votes: VotingResult;
    initiator: Account;
    currentVote: VotesType;

    constructor(id: number, name: string, branch: Branch, type: VotingType, status: VotingStatus, votes: VotingResult, initiator: Account, currentVote: VotesType) {
        this.id = id;
        this.name = name;
        this.branch = branch;
        this.type = type;
        this.status = status;
        this.votes = votes;
        this.initiator = initiator;
        this.currentVote = currentVote;
    }

    static createVoting(obj: any) {
        const model = new DiseaseParametersModel(obj.branch.cancerType, obj.branch.cancerStage, obj.branch.molecularAlterations, obj.branch.alterationType);
        const branch = new Branch(obj.branch.id, obj.branch.name, model);
        const status = new VotingStatus(obj.status.result, obj.status.left);
        const votes = new VotingResult(obj.votes.agree, obj.votes.disagree, obj.votes.abstain, obj.votes.ignored);
        const initiator = new Account(obj.initiator.id, obj.initiator.login, obj.initiator.role, '', obj.initiator.name, obj.initiator.surname);

        return new Voting(obj.id, obj.name, branch, obj.type, status, votes, initiator, obj.currentVote);
    }

    canVote(): boolean {
        return this.status.hasNoResult() && this.currentVote === VotesType.ignored;
    }

    getBranchNameAsString(): string {
        return this.branch.name;
    }

    getTypeAsString(): string {
        switch (this.type) {
            case VotingType.addTool:
                return "Treatment";

            case VotingType.addQuestion:
                return "Attribute";

            default:
                throw new Error("Unknown voting type!");
        }
    }

    getStatusAsString(): string | null {
        if (this.status.result === VotingResultType.none) {
            return "Left " + this.status.left;
        }

        switch (this.status.result) {
            case VotingResultType.accepted:
                return "Accepted";

            case VotingResultType.denied:
                return "Denied";

            default:
                throw new Error("Unknown status type!");
        }
    }

    getVotesAsString(): string {
        let result: string = '';

        if (this.votes.agree !== undefined) {
            result += `Agree: ${this.votes.agree} / `;
        }

        if (this.votes.disagree !== undefined) {
            result += `Disagree: ${this.votes.disagree} / `;
        }

        if (this.votes.abstain !== undefined) {
            result += `Abstain: ${this.votes.abstain} / `;
        }

        if (this.votes.ignored !== undefined) {
            result += `Ignored: ${this.votes.ignored}`;
        }

        return result;
    }

    getInitiatorAsString(): string {
        return this.initiator.surname + ' ' + this.initiator.name;
    }

    getCurrentVoteAsString(): string {
        switch (this.currentVote) {
            case VotesType.agree:
                return "Agree";

            case VotesType.disagree:
                return "Disagree";

            case VotesType.abstain:
                return "Abstain";

            case VotesType.ignored:
                return "Ignore";

            default:
                throw new Error("Unknown current vote!");
        }
    }
}
